"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExerciseDayCard = exports.ExerciseHistory = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const ExerciseInformation_1 = require("./ExerciseInformation");
const ExerciseCardBottomSection_1 = require("./ExerciseCardBottomSection");
const ExerciseSeriesParameters_1 = require("./ExerciseSeriesParameters");
const ExerciseHistory = ({ history }) => {
    const [day, dayNumber, month] = history.date.split(" ");
    return ((0, jsx_runtime_1.jsxs)(HistoryWrapper, { children: [(0, jsx_runtime_1.jsx)(typography_1.H4, { children: day }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: `${dayNumber} ${month}` }, void 0), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(ExerciseSeriesParameters_1.ExerciseSeriesParameters, { seriesData: history.seriesData }, void 0) }, void 0)] }, void 0));
};
exports.ExerciseHistory = ExerciseHistory;
const HistoryWrapper = styled_components_1.default.div `
  display: inline-block;
  flex: 0;

  & > h4 {
    text-transform: capitalize;
  }

  & > h4 + p {
    margin-bottom: ${({ theme }) => theme.spacings.xs};
  }

  & > div:first-of-type:empty {
    height: 1.5rem;
  }

  & > div:last-of-type {
    display: flex;
    flex-direction: column;

    & > div {
      display: flex;
    }
  }
`;
const hasProgression = (days) => {
    let hasProgression = false;
    days.forEach((day) => {
        if (day.sets.length) {
            hasProgression = true;
            return;
        }
    });
    return hasProgression;
};
const isEmptyProgression = (day) => !!day.sets.length;
const isProgression = (days) => days.length > 0 && hasProgression(days);
// TODO: should return always last two elements
const filterDisplayedHistory = (border) => (_, index) => {
    return index >= border - 2 && index < border;
};
const ExerciseDayCard = (props) => {
    var _a, _b;
    const showProgression = isProgression(props.exerciseData.historyProgressionDays);
    const [historyProgressionVisible, setHistoryProgressionVisibility] = (0, react_1.useState)(showProgression && props.shouldBeVisibleOnStart);
    const filledProgressionDays = props.exerciseData.historyProgressionDays.filter(isEmptyProgression);
    const [historyBorder, changeHistoryBorder] = (0, react_1.useState)(filledProgressionDays.length > 2 ? 4 : 2);
    const toggleHistoryProgression = () => {
        return setHistoryProgressionVisibility(!historyProgressionVisible);
    };
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(ExerciseInformation_1.ExerciseInformation, { translations: {
                        rating: props.translations.rating,
                        exerciseDesc: props.translations.exerciseDesc,
                        exerciseName: props.translations.exerciseName,
                        exerciseRest: props.translations.exerciseRest,
                        imageAlt: props.translations.image.altText
                    }, exerciseData: props.exerciseData, img: props.img }, void 0) }, void 0), ((_b = (_a = props.exerciseData) === null || _a === void 0 ? void 0 : _a.note) === null || _b === void 0 ? void 0 : _b.body) && ((0, jsx_runtime_1.jsx)(NoteWrapper, { isProgression: showProgression, children: (0, jsx_runtime_1.jsx)(typography_1.P, { children: props.exerciseData.note.body }, void 0) }, void 0)), historyProgressionVisible && ((0, jsx_runtime_1.jsxs)(HistoryGroup, { children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { children: props.translations.progression }, void 0), (0, jsx_runtime_1.jsx)("div", { children: filledProgressionDays
                            .filter(filterDisplayedHistory(historyBorder))
                            .map((history) => ((0, jsx_runtime_1.jsx)(exports.ExerciseHistory, { history: history }, history.date))) }, void 0)] }, void 0)), showProgression && ((0, jsx_runtime_1.jsx)(ExerciseCardBottomSection_1.ExerciseCardBottomSection, { toggleHistory: toggleHistoryProgression, translations: {
                    open: props.translations.openProgression,
                    close: props.translations.closeProgression
                }, historyVisible: Boolean(historyProgressionVisible), onLeft: () => changeHistoryBorder(historyBorder - 2), onRight: () => changeHistoryBorder(historyBorder + 2), disabledLeft: historyBorder <= 2, disabledRight: historyBorder >= filledProgressionDays.length }, void 0))] }, void 0));
};
exports.ExerciseDayCard = ExerciseDayCard;
const HistoryGroup = styled_components_1.default.div `
  border-top: 1px solid ${({ theme }) => theme.colors.silverLighten70};
  padding-top: ${({ theme }) => theme.spacings.m};

  & > div {
    min-width: 14.5rem;

    & > div:not(:last-of-type) {
      margin-right: ${({ theme }) => theme.spacings.xl};
    }
  }
`;
const Wrapper = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-radius: ${({ theme }) => theme.utils.radius};
  padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};

  h2,
  p {
    line-height: 1.5rem;
    margin-bottom: 0;
  }

  & > div:not(:last-of-type) {
    padding-bottom: ${({ theme }) => theme.spacings.m};
  }
`;
const NoteWrapper = styled_components_1.default.div `
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-radius: ${({ theme }) => theme.utils.radius};
  padding: ${({ theme }) => theme.spacings.m};
  ${({ isProgression, theme }) => isProgression ? `margin-bottom: ${theme.spacings.m}` : ""};
`;
//# sourceMappingURL=ExerciseDayCard.js.map